/* eslint-disable import/prefer-default-export */
export const USER_OBJECT = 'user_object';
